import "./Body.scss";
import React from "react";

export default function body() {
  return (
    <main className="body">
      <div className="body__overview">
        <div className="body__overview-wrap">
          <h3 className="body__overview-title">Conversions Overview</h3>
          <div className="body__overview-dropdown">
            <select name="dropdown" id="body__dropdown">
              <option value="All Pages">Last Year</option>
              <option value="All Pages">Last 3 Months</option>
              <option value="All Pages">Last 30 Days</option>
              <option value="All Pages">Last 7 Days</option>
            </select>
          </div>
        </div>
      </div>
      <div className="body__overview--bottom">
        <div className="body__card">
          <div className="body__card--left card greyscale"></div>
          <div className="body__card--mid card greyscale"></div>
          <div className="body__card--right card greyscale"></div>
        </div>
      </div>
      <div className="body__infograph">
        <div className="body__infograph--pie card-half "></div>
        <div className="body__infograph--map card-half"></div>
      </div>
      <div className="body__infograph">
        <div className="body__infograph--trend card-half"></div>
        <div className="body__infograph--heat card-half "></div>
      </div>
    </main>
  );
}
